export const SET_REGFORM_CONTACT = 'SET_REGFORM_CONTACT';
export const ADD_OR_SAVE_ENTRY = 'ADD_ENTRY';
export const DELETE_ENTRY = 'DELETE_ENTRY';
export const UNDELETE_ENTRY = 'UNDELETE_ENTRY';

export const ADD_DIALOG_OPEN = 'ADD_DIALOG_OPEN';
export const ADD_DIALOG_SELECT_CATEGORY = 'ADD_DIALOG_SELECT_CATEGORY';
export const ADD_DIALOG_UPDATE_PLAYER = 'ADD_DIALOG_UPDATE_PLAYER';
export const ADD_DIALOG_UPDATE_PLAYER_PARAM = 'ADD_DIALOG_UPDATE_PLAYER_PARAM';
export const ADD_DIALOG_FIX_NAME_CASE = 'ADD_DIALOG_FIX_NAME_CASE';

export const SUBMIT_REGISTRATION = 'SUBMIT_REGISTRATION';
export const SUBMIT_REGISTRATION_STARTED = 'SUBMIT_REGISTRATION_STARTED';
export const SUBMIT_REGISTRATION_SUCCESS = 'SUBMIT_REGISTRATION_SUCCESS';
export const SUBMIT_REGISTRATION_ERROR = 'SUBMIT_REGISTRATION_ERROR';
export const SUBMIT_REGISTRATION_DIALOG_CLOSE = 'SUBMIT_DIALOG_REGISTRATION_CLOSE';

export const SUBMIT_DIALOG_STATUS = {
    IDLE: 'IDLE',
    IN_PROGRESS: 'IN_PROGRESS',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS'
};

export const ADD_DIALOG_MODE = {
    ADD_NEW: 'ADD_NEW', // ADD_NEW == new entry in form
    EDIT_EXISTING: 'EDIT_EXISTING',  // EDIT_EXISTING == edit an existing entry that has already been saved on the server
    EDIT_NEW: 'EDIT_NEW' // EDIT_NEW == edit a new entry that has not yet been saved on the server
};

export default {
    SET_REGFORM_CONTACT, ADD_OR_SAVE_ENTRY, DELETE_ENTRY, UNDELETE_ENTRY, ADD_DIALOG_MODE,
    ADD_DIALOG_OPEN, ADD_DIALOG_SELECT_CATEGORY, ADD_DIALOG_UPDATE_PLAYER, ADD_DIALOG_UPDATE_PLAYER_PARAM,
    SUBMIT_REGISTRATION, SUBMIT_REGISTRATION_ERROR, SUBMIT_REGISTRATION_STARTED, SUBMIT_REGISTRATION_SUCCESS,
    SUBMIT_REGISTRATION_DIALOG_CLOSE, SUBMIT_DIALOG_STATUS, ADD_DIALOG_FIX_NAME_CASE
};